import Picture from "@/components/picture";
import Avatar from "@/components/avatar";
import { mapState, mapMutations } from "vuex";
import { conversion, countDownS } from "@/tool";
import SteamTradeUrlModal from "@/pages/user/components/steam_trade_url_modal";

export default {
  name: "user",

  components: {
    "c-picture": Picture,
    "c-avatar": Avatar,
    "steam-trade-url-modal": SteamTradeUrlModal,
  },

  filters: {
    conversion,
    countDownS,
  },

  data() {
    return {
      hasRank: 0,
      userinfo: {
        activename: "userinfo",
        opennames: ["userinfo"],
      },

      /** 侧栏菜单显示 */
      is_sidebar_menu_show: false,
      aclList: [],

      /** 绑定Steam交易连接弹窗 */
      modifyTradeModal: { flag: false, url: "" },
    };
  },

  watch: {
    $route() {
      this.userinfo = {
        activename: this.$route.name,
        opennames: [this.$route.name],
      };
    },
  },
  computed: {
    ...mapState(["user", "config", "information", "acl"]),
  },
  async created() {
    this.userinfo.activename = this.$route.name;

    if (["inventory", "userInfo", "wallet"].indexOf(this.$route.name) !== -1) {
      this.userinfo.opennames = ["inventory"];
    }

    setTimeout(() => {
      this.hasRank = Number(sessionStorage.getItem("hasRank")) || 0;
    }, 2000);
  },
  async mounted() {
    this.aclList = this.acl;
  },
  methods: {
    ...mapMutations(["setPayModal", "setRedPacketModal", "setInfo"]),
    /** 点击 STEAM 交易链接：无 tradeUrl 时直接打开绑定弹窗，有则跳转个人资料 */
    onTradeUrlClick() {
      if (!this.user.tradeUrl) {
        this.modifyTradeModal.flag = true;
        this.modifyTradeModal.url = "";
      } else {
        this.$router.push({ name: "userinfo" });
      }
    },
    /** 切换侧栏菜单显示状态 */
    async toggle_sidebar_menu_show() {
      this.is_sidebar_menu_show = !this.is_sidebar_menu_show;
    },
  },
};
